export default ({ palette, spacing, typography }) => ({
  branches: {
    applyButton: {
      background: palette.branches.button.background,
      borderColor: palette.branches.button.borderColor,
      borderRadius: 10,
      color: palette.branches.button.color,
      fontFamily: typography.branches.fontFamilies.secondary,
      fontSize: 26,
      fontWeight: typography.fontWeights.regular,
      hoverBackground: palette.branches.button.hoverBackground,
      hoverBorderColor: palette.branches.button.hoverBorderColor,
      hoverColor: palette.branches.button.hoverColor,
    },
    selectButton: {
      activeBackground: palette.branches.button.activeBackground,
      activeBorderColor: palette.branches.button.activeBorderColor,
      activeColor: palette.branches.button.activeColor,
      background: palette.branches.button.background,
      borderColor: palette.branches.button.borderColor,
      borderRadius: 0,
      color: palette.branches.button.color,
      fontFamily: typography.branches.fontFamilies.primary,
      fontSize: 18,
      fontWeight: typography.fontWeights.regular,
      hoverBackground: palette.branches.button.hoverBackground,
      hoverBorderColor: palette.branches.button.hoverBorderColor,
      hoverColor: palette.branches.button.hoverColor,
    },
    setButton: {
      background: palette.branches.button.background,
      borderColor: palette.branches.button.borderColor,
      borderRadius: 40,
      color: palette.branches.button.color,
      fontFamily: typography.branches.fontFamilies.primary,
      fontSize: 18,
      fontWeight: typography.fontWeights.regular,
      hoverBackground: palette.branches.button.hoverBackground,
      hoverBorderColor: palette.branches.button.hoverBorderColor,
      hoverColor: palette.branches.button.hoverColor,
    },
    subnavigation: {
      activeBackground: palette.branches.subnavigation.activeBackground,
      activeColor: palette.branches.subnavigation.activeColor,
      background: palette.branches.subnavigation.background,
      color: palette.branches.subnavigation.color,
      fontFamily: typography.branches.fontFamilies.primary,
      fontWeight: typography.fontWeights.regular,
    },
    tab: {
      background: palette.branches.tab.background,
      color: palette.branches.tab.color,
      fontFamily: typography.branches.fontFamilies.primary,
      fontSize: 20,
      fontWeight: typography.fontWeights.regular,
      hoverColor: palette.branches.tab.hoverColor,
    },
  },
  primary: {
    background: palette.secondary,
    border: '1px solid',
    borderColor: palette.secondary,
    borderRadius: 10,
    color: palette.primary,
    fontFamily: typography.fontFamilies.primary,
    fontSize: 26,
    fontWeight: typography.fontWeights.medium,
    hoverBackground: palette.accent,
    hoverBorderColor: palette.accent,
    hoverColor: palette.primary,
    padding: `9px ${spacing.sm}px`,
  },
  secondary: {
    background: palette.primary,
    border: '1px solid',
    borderColor: palette.primary,
    borderRadius: spacing.unit * 2,
    color: palette.secondary,
    fontFamily: typography.fontFamilies.secondary,
    fontSize: 18,
    fontWeight: typography.fontWeights.regular,
    hoverBackground: palette.primary,
    hoverBorderColor: palette.primary,
    hoverColor: palette.secondary,
    padding: `9px ${spacing.sm}px`,
  },
  tertiary: {
    background: palette.primary,
    border: '1px solid',
    borderColor: palette.secondary,
    borderRadius: 10,
    color: palette.secondary,
    fontFamily: typography.fontFamilies.secondary,
    fontSize: 18,
    fontWeight: typography.fontWeights.normal,
    hoverBackground: palette.primary,
    hoverBorderColor: palette.primary,
    hoverColor: palette.secondary,
    margin: [spacing.md, 'auto'],
    padding: `9px ${spacing.sm}px`,
  },
});
